// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__3pIIy","row":"style_row__24jDj","title":"style_title__2Cf6v","outlined":"style_outlined__13iAy"};